import React from "react";

const StatusList = () => {
  return (
    <div>
      <h1>dcdc</h1>
    </div>
  );
};

export default StatusList;
